import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from 'react-bootstrap-5';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import ContactSelector from 'bundles/backoffice/contacts/selector';
import ManagedInput from 'components/form/managed_input';

import type { Contact } from 'bundles/backoffice/contacts/types';
import type { FormContact, FormEmployment } from 'bundles/backoffice/contacts/forms/types';

interface Props {
  allowSavingPrivateContacts?: boolean;
  businessRecord: FormEmployment;
  contact: FormContact;
  count: number;
  enableJobTitle?: boolean;
  index: number;
  onChange: (business: Contact | null) => void;
  onJobTitleChange: (jobTitle: string) => void;
  onPrimaryChange: () => void;
  onRemove: () => void;
}

export function ContactFormBusinessInput({
  allowSavingPrivateContacts,
  businessRecord,
  contact,
  count,
  enableJobTitle,
  index,
  onChange,
  onJobTitleChange,
  onPrimaryChange,
  onRemove,
}: Props) {
  return (
    <div className="form-group">
      <div className="d-flex justify-content-between align-items-center gap-2">
        <Form.Label className="flex-fill">
          Company
        </Form.Label>

        {count > 1 && <>
          <Form.Check
            checked={businessRecord.primary}
            id={`business-record-primary-${index}`}
            label="Primary"
            type="radio"
            onChange={onPrimaryChange}
          />

          <FontAwesomeIcon
            icon={faTrashAlt}
            onClick={onRemove}
          />
        </>}
      </div>

      <div className="row g-2">
        <div className="col">
          <ContactSelector
            contact={businessRecord.business}
            contactType="business"
            menuPlacement="top"
            newContactVisibility={!allowSavingPrivateContacts && contact.private ? 'shared' : contact.visibility}
            onChange={onChange}
          />
        </div>

        {enableJobTitle &&
          <div className="col-12 col-sm-auto">
            <ManagedInput
              className="form-control"
              placeholder="Job Title"
              value={businessRecord.jobTitle}
              onValueChange={onJobTitleChange}
            />
          </div>
        }
      </div>
    </div>
  );
}
